export default __webpack_public_path__ + "594041393209f0003754755fbabaefc8.woff2";